(ns frontend.view.grid.persons-grid.db
  (:require [frontend.db :as app-db]
            [reagent.core :as r]))

(defonce contacts (r/cursor app-db/views [:contacts]))
(defonce modal-state (r/cursor contacts [:modals]))
(defonce grid-entities (r/cursor contacts [:grid-entities]))
(defonce view-settings (r/cursor contacts [:view-settings]))
(defonce contact-filters (r/cursor view-settings [:filters]))
(defonce selected-columns (r/cursor view-settings [:selected-columns]))
(defonce column-widths (r/cursor view-settings [:column-widths]))
(defonce ordered-columns (r/cursor view-settings [:ordered-columns]))

;;kanban related:
(defonce kanban (r/cursor contacts [:kanban]))
(defonce expanded (r/cursor kanban [:expanded]))
(defonce grouped-by (r/cursor view-settings [:grouped-by]))
(defonce card-settings (r/cursor view-settings [:card-settings]))
(defonce lists (r/cursor kanban [:lists]))
(defonce sorted-kanban-entities (r/cursor contacts [:sorted-kanban-entities]))

;;precalculated schema (for performance reasons):
(defonce schema (r/cursor contacts [:schema]))
